import { emptyLoyaltyEstimate, LoyaltyEstimate } from 'types/Loyalty';

export interface LoyaltyState {
    estimate: LoyaltyEstimate;
    loading: boolean;
}

export const initialLoyaltyState: LoyaltyState = {
    estimate: emptyLoyaltyEstimate,
    loading: false
};
